import { alpha, darken, IconButton, lighten, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import { localImageSrc } from "app/images";
import { useBreakpointQuery } from "hooks/useBreakPointQuery";
import { theme } from "app/theme";

export const SANGHA_MEMBERS_HIDDEN_HEIGHT = 42;

const getBackgroundStyle = (width?: number) =>
    `linear-gradient(${alpha(theme.palette.grey900, 0.15)}, ${alpha(
        theme.palette.grey900,
        0.15,
    )}), url(${localImageSrc("bg2-min.jpg", width)})`;

const useStyles = makeStyles((theme) => ({
    container: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: darken(theme.palette.primary500, 0.1),
        backgroundSize: "cover",
        backgroundPosition: "50% 50%",
        color: theme.palette.coral100,
        cursor: "pointer",

        backgroundImage: getBackgroundStyle(400),
        [theme.breakpoints.up(400)]: {
            backgroundImage: getBackgroundStyle(600),
        },
        [theme.breakpoints.up(600)]: {
            backgroundImage: getBackgroundStyle(960),
        },
        [theme.breakpoints.up(960)]: {
            backgroundImage: getBackgroundStyle(1280),
        },
        [theme.breakpoints.up(1280)]: {
            backgroundImage: getBackgroundStyle(),
        },
    },
    linkContainer: {
        margin: theme.spacing(2, 0, 1, 0),
        textAlign: "center",
    },
    link: {
        cursor: "pointer",
    },
    openButton: {
        position: "absolute",
        left: "50%",
        top: 0,
        transform: "translateX(-50%) translateY(-40%)",
        color: theme.palette.coral100,
        backgroundColor: theme.palette.primary500,
        border: theme.border.default,
        padding: 0,
        "&:hover": {
            backgroundColor: lighten(theme.palette.primary500, 0.1),
        },
    },
}));

export const SanghaMembersHidden = (props: { onOpen: VoidFunction }) => {
    const classes = useStyles();
    const isMobile = useBreakpointQuery("sm");

    return (
        <div className={classes.container} onClick={props.onOpen}>
            <IconButton
                classes={{ root: classes.openButton }}
                data-testid="showSanghaMembersButton"
            >
                <ExpandLessRoundedIcon />
            </IconButton>

            <Typography variant="body2" className={classes.linkContainer}>
                <span className={classes.link}>
                    <strong>{isMobile ? "Sangha details" : "See my group"}</strong>
                </span>
            </Typography>
        </div>
    );
};
